import type { FormInputType } from '@/components/UI/Form/types'

import { SafetyReportStatus } from '../safetyReport'

export default function getChangeSafetyReportStatusFormInputs(): FormInputType[] {
  const formInputs: FormInputType[] = [
    {
      type: 'select',
      label: 'Choose a status',
      name: 'status',
      required: true,
      options: [
        { label: 'Awaiting User Response', value: SafetyReportStatus.AwaitingUserResponse },
        { label: 'Needs Action', value: SafetyReportStatus.NeedsAction },
        { label: 'In Progress', value: SafetyReportStatus.InProgress },
        { label: 'Resolved', value: SafetyReportStatus.Resolved },
      ],
      size: 6,
    },
    {
      label: 'Add a note',
      sublabel:
        'Describe why you’re changing the status and any relevant actions you’ve taken for the tutor.',
      type: 'textarea',
      name: 'comment',
      required: true,
      size: 6,
    },
  ]
  return formInputs
}
